import { Box } from "@mui/material";
import { getWithToken } from "../fetchWithToken";
import { useEffect, useState } from "react";
import { OverviewCard } from "../components/OverviewCard.js";

export const YearlyOverview = ({ year }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        Promise.all([
            getWithToken('/api/statistic/profit/', { 'year': year })
        ]).then(([profitData]) => {
            const totalIncome = profitData?.income?.reduce((a, b) => a + b, 0) || 0;
            const totalExpense = profitData?.expense?.reduce((a, b) => a + Math.abs(b), 0) || 0;
            const totalProfit = profitData?.profit?.reduce((a, b) => a + b, 0) || 0;

            setData({
                totalIncome: totalIncome.toFixed(0),
                totalExpense: totalExpense.toFixed(0),
                totalProfit: totalProfit.toFixed(0)
            });
        }).catch(err => {
            console.error('获取年度总览失败:', err);
        }).finally(() => {
            setLoading(false);
        });
    }, [year]);

    if (loading || !data) {
        return (
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                {[1, 2, 3].map((i) => (
                    <Box key={i} sx={{
                        flex: { xs: '1 1 150px', sm: '1 1 200px' },
                        height: 80,
                        bgcolor: 'grey.100',
                        borderRadius: 2
                    }} />
                ))}
            </Box>
        );
    }

    const overviewData = {
        income: { total: Number(data.totalIncome) },
        expense: { total: Number(data.totalExpense) },
        balance: Number(data.totalProfit)
    };

    return (
        <Box sx={{ mb: 2 }}>
            <OverviewCard
                data={overviewData}
                size="large"
                incomeLabel="总收入"
                expenseLabel="总支出"
                balanceLabel="年度结余"
            />
        </Box>
    );
};
